export default "__VITE_ASSET__BUebKSYh__"